import { ChatMessagePayloadAttachment } from "@jugl-web/rest-api";

export const clearAttachmentsLocalAttributes = (
  attachments: ChatMessagePayloadAttachment[]
): ChatMessagePayloadAttachment[] =>
  attachments.map((attachment) => {
    const result = { ...attachment };
    delete result?._local_url;
    delete result?._progress;
    delete result?._preview_url;
    delete result?._stream_url;
    return result;
  });
